<template>
	<div
		class="search"
		:class="[disabled && 'is-disabled']"
		:disabled="disabled"
		:style="searchStyle"
	>
		<Input
			class="search__input"
			:tabindex="disabled ? -1 : 0"
			name="search"
			ref="search"
			type="text"
			:aria-label="label"
			v-model="searchText"
			:placeholder="placeholder"
			@change="updateSearchText"
			v-focus="hasFocus"
			@keyup="onKeyup"
			autocomplete="off"
			:hasClearFeature="hasClearFeature"
			@input="updateSearchText"
		/>
		<span class="search__btn">
			<ButtonIcon
				@click="doSearch"
				iconClassName="icon-search"
				:labelText="buttonLabelText"
				:class="[disabledSearchButton && 'is-disabled']"
				:disabled="disabled"
			/>
		</span>
	</div>
</template>

<script>
import Input from '@/components/forms/input/input.vue';
import ButtonIcon from '@/components/forms/button/button-icon.vue';
import baseComponentMixin from '@/mixins/base-component-mixin';
import baseButtonMixin from '@/mixins/base-button-mixin';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import focusMixin from '@/mixins/focus-mixin';

export default {
	name: 'Search',
	mixins: [
		baseComponentMixin,
		baseButtonMixin,
		componentVariantMixin,
		focusMixin
	],
	created() {},
	data() {
		return {
			searchText: this.value,
			lastSearchText: this.value,
			availableSearch: true
		};
	},
	components: {
		ButtonIcon,
		Input
	},
	props: {
		value: {
			type: String
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		iconClassName: {
			type: String,
			default: 'icon-search'
		},
		disabledSearch: {
			type: Boolean,
			default: undefined
		},
		buttonLabelText: {
			type: String,
			default: 'Search'
		},
		hasClearFeature: {
			type: Boolean,
			default: false
		}
	},
	mounted() {},
	computed: {
		disabledSearchButton() {
			if (!this.searchText || this.searchText.length === 0) return true;
			if (
				this.searchText === this.lastSearchText &&
				this.disabledSearch === undefined
			) {
				return true;
			}
			if (this.disabledSearch !== undefined) {
				return this.disabledSearch;
			}
			return false;
		},
		searchStyle() {
			if (typeof this.width === 'number') {
				return {
					width: `${this.width}px`
				};
			} else {
				return {
					width: this.width
				};
			}
		}
	},
	methods: {
		updateSearchText() {
			this.$emit('input', this.searchText);
			this.$emit('change', this.searchText);
		},
		onKeyup(event) {
			if (event.keyCode === 13) {
				this.doSearch();
			} else {
				this.$emit('input', this.searchText);
			}
		},
		doSearch() {
			if (!this.disabledSearchButton) {
				this.$emit('search', this.searchText);
				this.lastSearchText = this.searchText;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.search {
	display: inline-flex;
	align-items: center;
	position: relative;
	color: var(--field-fg);

	&__input {
		width: 100%;
	}

	&__btn {
		font-size: $base-font-size;
	}

	.btn-icon {
		@include input-height;
		padding: $field-padding-y $field-padding-x;
		border: $field-border;
		border-left: 0;
		border-radius: 0 $border-radius $border-radius 0;
	}

	&:deep(.input__field-container){
		border-radius: $border-radius 0 0 $border-radius;
	}
	// These styles are in relation to the focus border. The width changes to adapt to the btn-icon-clear mixin styles on the button-icon.

	&:deep(.input__field-container):focus-within::after {
		left: -1px;
		width: calc(100% + 41px);

		@include mq($from: lg) {
			width: calc(100% + 35px);
		}
	}

	&:deep(.btn-icon) {

		&:hover {
			background-color: var(--bg-brand-2-tint);
			color: var(--bg-brand-2-tint-fg-2);

			.icon:after {
				border: none;
			}
		}
		&:focus,
		&:active {
			outline: $focus-width $focus-style var(--brand-2);
			outline-offset: $focus-offset;

			.icon:after {
				border: none;
			}
		}
	}
}
</style>
